import { Controller } from "@hotwired/stimulus";
import Autonumeric from 'autonumeric';

export default class extends Controller {
    connect() {
        let options = JSON.parse(this.element.dataset['autonumeric']);
        new Autonumeric(this.element, options);
    }
}
